import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import crmDesktop from "../../images/crmDesktop.jpg";
import crmMobile from "../../images/crmMobile.jpg";

const Crm = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };

  return (
    <div className="portfolio-element">
      <div className="portfolio-right">
        <h1 className="headings-portfolio">CRM/CRUD App</h1>
        <p>
          Desarrollo de una aplicación (CRM), donde el usuario tiene la
          capacidad de Agregar / Editar / Eliminar clientes y eventos asociados
          con los clientes. Todos se guardan en Strapi, por lo que el usuario
          básicamente puede iniciar sesión en cualquier lugar y tener acceso. La
          aplicación usa Javascript para el sistema de autenticación y el
          usuario se ve obligado a verificar su contraseña (contraseña: admin)
          antes de usar la aplicación.
        </p>
        <a target="blank" href="https://crm-strapi.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a
          target="blank"
          href="https://github.com/khanchandanivikas/crm-strapi"
        >
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
      <div className="portfolio-left">
        <img src={desktop ? crmDesktop : crmMobile} alt="CRUD App" />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
    </div>
  );
};

export default Crm;
